import type { FunctionComponent, ReactNode } from 'react';
import styles from './FloatingToolbar.module.less';

type Props = {
  /**
   * Whether the floating toolbar should be displayed.
   */
  shouldShow: boolean;
  /**
   * The message to display in the floating toolbar.
   */
  text: string;
  /**
   * The actions to display in the floating toolbar. (e.g. buttons)
   */
  actions: ReactNode;
};

/**
 * Display a floating toolbar with a message and actions.
 * The floating toolbar will be displayed at the bottom of the screen with a fixed position.
 */
const FloatingToolbar: FunctionComponent<Props> = ({ text, actions, shouldShow }) => {
  if (!shouldShow) {
    return null;
  }

  return (
    <div
      className={styles.floatingToolbar}
    >
      <span className={styles.text}>{text}</span>
      {actions}
    </div>
  );
};

export default FloatingToolbar;
